import React, { useEffect, useState } from 'react';
import styles from './deal.module.css';
import DealCreationSteps from './DealCreationSteps/DealCreationSteps';
import Header from '../../../components/Header/Header';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Button from '../../../components/Button/Button';

import leads from '../../../brand/generated/sidebar/deals.svg';
import DealCreationMainInfo from './DealCreateMainInfo';
import DealCreateEquipment from './DealCreateEquipment';
import DealCreateServices from './DealCreateServices';
import DealCreateDocs from './DealCreateDocs';
import DealCreateOther from './DealCreateOther';
import Alert from '../../../components/Alert/Alert';
import { useNavigate } from 'react-router-dom';
import addItemsToDeal from '../../../api/deals/addItemsToDeal';
import getDealCars from '../../../api/deals/getDealCars';
import formatNumber from '../../../utils/formatNumber';
import { textStyles } from '../../../constants/textStyles';
import addDealComment from '../../../api/deals/addDealComment';
import setStep from '../../../api/deals/setStep';
import LoaderInline from '../../../components/Loader/LoaderInline';
import DealCreateCreditAppeal from './DealCreateCreditAppeal';
import BCCFlow from './BCCFlow';

import {
  BANKS,
  DEAL_STATUS_DOCUMENTS_PROCESSING,
  DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STATUS_FILLING_QUESTIONNAIRE,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_POLES,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
  PAYMENT_STATUS_PAID,
  PAYMENT_TYPES_CREDIT_CARD,
  PAYMENT_TYPES_CREDIT_INVOICE,
  PAYMENT_TYPES_PREPAYMENT_CARD,
  PAYMENT_TYPES_PREPAYMENT_INVOICE,
} from '../../../constants';
import uploadDocumentToDeal from '../../../api/deals/uploadDocumentToDeal';
import createCreditAppeal from '../../../api/creditPlatform/createCreditAppeal';
import DealCreateBanks from './DealCreateBanks';
import DealCreateBanksPay from './DealCreateBanksPay';
import generateUserAgreement from '../../../api/creditPlatform/generateUserAgreement';
import DealCreatePayment from './DealCreatePayment';
import editDeal from '../../../api/deals/editDeal';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';
import DealCreateCreditDocuments from './DealCreateCreditDocuments';
import DealCreatePledgeRegistration from './DealCreatePledgeRegistration';
import generateAllowedDocumentsJson from '../../../utils/generateAllowedDocumentsJson';
import getCreditAppeal from '../../../api/deals/getCreditAppeal';
import getCreditAppealSilent from '../../../api/deals/getCreditAppealSilent';
import SendAppealProgress from './SendAppealProgress';
import { resolveAppealState, shouldShowSendProgress } from '../../../utils/appealSubmitState';
import HalykFlow from './HalykFlow';
import FreedomFlow from './FreedomFlow';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import ForteFlow from './ForteFlow';
import ClientPaymentApprove from './ClientPaymentApprove';
import toastAlert from '../../../helpers/alert';
import BerekeFlow from './BerekeFlow';
import ClientRegistrationApprove from './ClientRegistrationApprove';
import AltynFlow from './AltynFlow';
import EurazFlow from './EurazFlow';
import ContractSign from './CommonBankSteps/ContractSign';
import TripartiteContractStep from './CommonBankSteps/TripartiteContractStep/index';
import bankFirstStep, { isConsignmentDeal as carsHaveConsignment, stepAfterBankSelect } from './bankFirstStep';
const DealCreate = ({ deal: savedDeal, cars, equipments, services, update, documents, loading, setLoading }) => {
  const [state, setState] = useState({});
  const [sum, setSum] = useState(0);
  const [currentStep, setCurrentStep] = useState(savedDeal?.step || 1);
  const [succes, setSucces] = useState({});

  const [deal, setDeal] = useState(savedDeal);
  const [orders, setOrders] = useState([]);
  const [usedCar, setUsedCar] = useState(false);
  const [unsavedEquipments, setUnsavedEquipments] = useState([]);
  const [unsavedServices, setUnsavedServices] = useState([]);
  const [agreementModal, setAgreementModal] = useState(false);
  const [chosenBankId, setChosenBankId] = useState(null);
  const [chosenBankAppealId, setChosenBankAppealId] = useState(null);
  const [chosenBankAppeal, setChosenBankAppeal] = useState(null);
  const [creditAppeals, setCreditAppeals] = useState([]);

  const isCreditDeal =
    deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE;

  const isConsignmentDeal = carsHaveConsignment(cars);

  useEffect(() => {
    let cancelled = false;
    if (savedDeal?.id) {
      getDealCars({ id: savedDeal?.id }).then((res) => {
        const options = res?.data?.cars?.map((item) => {
          return {
            label: `${item.mark} ${item.model} (VIN ${item?.vin}, ${item?.complectation?.title}, ${
              item?.complectation?.engine?.title
            }, ${formatNumber(item?.container?.toPrice)} ₸)`,
            value: item?.orderId,
          };
        });

        setOrders(options);
        // БУ-авто (выкуп, мена, поручение) — заявки только в банки из USED_CAR_BANK_IDS.
        setUsedCar((res?.data?.cars || []).some((item) => item?.used === true));
      });

      getCreditAppeal({ chunkId: savedDeal?.chunkId }).then((res) => {
        if (cancelled) return;
        const appeals = res?.data?.appeals || [];
        const chosenBank = appeals.find((appeal) => appeal?.selected) || (appeals.length === 1 ? appeals[0] : null);
        const fromAppeal = chosenBank?.bank?.id || chosenBank?.bankId;
        const onlyDealBank = savedDeal?.bankIds?.length === 1 ? savedDeal.bankIds[0] : null;
        // Заявки сохраняем всегда: из них правая панель берёт дату подачи, субсидию
        // и семейное положение. Раньше выход по отсутствию банка стоял выше — и пока
        // клиент не выбрал предложение, эти поля на экране просто пропадали.
        setCreditAppeals(appeals);

        const bankId = fromAppeal || onlyDealBank;
        if (!bankId) return;
        setChosenBankId(bankId);
        if (chosenBank) {
          setChosenBankAppealId(chosenBank.id);
          setChosenBankAppeal(chosenBank);
        }
      });
    }
    setDeal(savedDeal);
    return () => {
      cancelled = true;
    };
  }, [savedDeal]);

  const onSubmitStep1 = () => {
    update && update();
  };
  const onEquipmentSubmit = (equipments, orderId) => {
    setLoading(true);
    addItemsToDeal({
      cars: [{ orderId: String(orderId), value: String(orderId) }],
      dealId: String(deal?.id),
      equipments,
      step: 3,
    })
      .then(() => {
        setUnsavedEquipments([]);
        update();
        setCurrentStep(3);
      })
      .catch((err) => alert(err))
      .finally(() => setLoading(false));
  };
  const onSubmitStep3 = (services, orderId, step = 4) => {
    setLoading(true);
    addItemsToDeal({
      cars: [{ orderId: String(orderId), value: String(orderId) }],
      dealId: String(savedDeal?.id),
      services,
    })
      .then(async () => {
        setUnsavedServices([]);
        // Предоплата: следующий шаг — оплата. Кредит: следующий шаг — анкета,
        // «Ожидает оплаты» там вводил менеджеров в заблуждение.
        const isCredit =
          savedDeal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE ||
          savedDeal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD;
        await editDeal({
          dealId: savedDeal?.id,
          id: savedDeal?.id,
          statusId: isCredit ? DEAL_STATUS_FILLING_QUESTIONNAIRE : DEAL_STATUS_WAITING_FOR_PAYMENT,
          paymentTypeId: savedDeal?.paymentType?.id,
          equipmentStepPassed: true,
          ...generateAllowedDocumentsJson(
            savedDeal?.paymentType?.id == PAYMENT_TYPES_PREPAYMENT_INVOICE
              ? [DOCUMENT_TYPES_INVOICE]
              : [DOCUMENT_TYPES_TECH_PASSPORT]
          ),
        });
        setStep({ dealId: savedDeal?.id, step }).then(() => {
          update();
        });
      })
      .catch((err) => alert(err))
      .finally(() => setLoading(false));
  };
  const onSubmitStep4 = () => {
    update();
  };

  const [sendFormLoading, setSendFormLoading] = useState(false);
  // Прогресс отправки заявки: сколько банков уже ответило и что с каждым.
  const [sendProgress, setSendProgress] = useState(null);
  const [sendProgressError, setSendProgressError] = useState(null);
  const sendPollRef = React.useRef(null);
  const lastSubmitRef = React.useRef(null);

  React.useEffect(() => () => clearTimeout(sendPollRef.current), []);

  // Заявки текущей отправки отличаем по id: всё, что больше последнего
  // существующего на момент нажатия. По времени нельзя — createdAt приходит
  // в UTC, а часы браузера живут в своей зоне.
  const readAppeals = (chunkId) =>
    getCreditAppealSilent({ chunkId })
      .then((res) => res?.data?.appeals || [])
      .catch(() => null);

  const stopSendPolling = () => {
    clearTimeout(sendPollRef.current);
    sendPollRef.current = null;
  };

  // Окно прогресса поднимаем только когда заявки реально появились. На первом
  // клике их ещё нет: бэкенд отвечает «ОТП не подписан», и менеджер идёт
  // отправлять клиенту согласие. Показывать в этот момент «отправляем в банки»
  // — врать.
  const startSendPolling = (chunkId, baselineId, total) => {
    stopSendPolling();
    // Первый опрос делаем быстрым: заявки создаются в базе в первую же секунду,
    // и менеджер должен увидеть окно сразу, а не через полторы секунды пустого
    // экрана. Дальше опрашиваем реже — ответы банков идут секундами.
    let delay = 300;

    const tick = async () => {
      const appeals = await readAppeals(chunkId);
      const fresh = (appeals || []).filter((appeal) => appeal?.id > baselineId);
      if (fresh.length > 0) {
        setSendProgress({
          total: Math.max(total, fresh.length),
          banks: fresh
            .sort((a, b) => a.id - b.id)
            .map((appeal) => ({
              id: appeal.id,
              name: appeal?.bank?.name || `Банк ${appeal?.bankId}`,
              state: resolveAppealState(appeal),
            })),
        });
      }
      if (sendPollRef.current === null) return;
      sendPollRef.current = setTimeout(tick, delay);
      delay = 1200;
    };

    sendPollRef.current = setTimeout(tick, delay);
    delay = 1200;
  };

  const handleCreateCreditSubmit = async (values, documents, files, showError = false) => {
    lastSubmitRef.current = { values, documents, files, showError };
    const chunkId = deal?.chunkId;
    const total = values?.bankIds?.length || 0;

    try {
      documents.map((doc) => uploadDocumentToDeal(doc));
      setSendFormLoading(true);
      setSendProgressError(null);
      setSendProgress(null);
      // Окно подписания согласия своё отработало — закрываем сразу, а не когда
      // придут первые ответы: иначе оно ещё пару секунд висит сверху пустым
      // серым прямоугольником со спиннером. Если окажется, что согласие всё-таки
      // не подписано, бэкенд ответит «ОТП не подписан» и окно откроется снова.
      setAgreementModal(false);

      const before = chunkId ? await readAppeals(chunkId) : [];
      const baselineId = (before || []).reduce((max, i) => Math.max(max, i?.id || 0), 0);
      if (chunkId) startSendPolling(chunkId, baselineId, total);

      return createCreditAppeal(
        {
          ...values,
          MaritalStatus: values?.MaritalStatus?.value,
        },
        files
      )
        // Возвращаем { sent }, чтобы анкета знала, уходила ли заявка на самом
        // деле. Черновик формы можно стирать только после реальной отправки:
        // на первом клике банк ещё ждёт подписанного согласия, и обнулять
        // введённые данные тут нельзя.
        .then(() => {
          stopSendPolling();
          setSendProgress(null);
          setStep({ dealId: deal?.id, step: 5 }).then(() => {
            update();
          });
          return { sent: true };
        })
        .catch(async (err) => {
          stopSendPolling();
          if (err?.response?.data?.error == 'ОТП не подписан') {
            setSendProgress(null);
            setAgreementModal(true);
            return { sent: false };
          }
          // Ответ до нас не дошёл — но заявки могли уйти. Шаг сделки теперь
          // ставит бэкенд, поэтому просто проверяем, появились ли заявки, и
          // не заставляем менеджера перекидывать сделку руками.
          const after = chunkId ? await readAppeals(chunkId) : null;
          const created = (after || []).filter((appeal) => appeal?.id > baselineId);
          if (created.length > 0) {
            setSendProgress(null);
            update();
            return { sent: true };
          }
          setSendProgressError(
            extractErrorMessage(err) ||
              'Заявка не ушла в банки. Проверьте связь и попробуйте отправить ещё раз.'
          );
          return { sent: false };
        })
        .finally(() => {
          setSendFormLoading(false);
        });
    } catch (e) {
      console.log(e);
      stopSendPolling();
      setSendFormLoading(false);
      setSendProgressError('Заявка не ушла в банки. Попробуйте отправить ещё раз.');
    }
  };

  const onSubmitStep5 = (values) => {
    addDealComment({
      managerId: String(values?.managerId?.value),
      dealId: String(savedDeal?.id),
      comment: values?.comment,
    }).then(() => {
      setStep({ dealId: savedDeal?.id, step: 10 }).then(() => {
        update();
      });
    });
  };

  const onBankSelect = (bankId, appeal) => {
    console.log('BANKID', bankId);
    setChosenBankId(bankId);
    setChosenBankAppeal(appeal || null);
    setChosenBankAppealId(appeal?.id ?? null);
    // Авто по договору поручения: между выбором банка и ДКП вклинивается
    // отдельный шаг с трёхсторонним договором, дальше поток банка продолжается.
    const nextStep = stepAfterBankSelect(bankId, appeal, cars);
    //check bank id and move to the flow of this bank
    if (bankId === BANKS.HALYK) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.FREEDOM) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.FORTE) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }

    if (bankId === BANKS.BEREKE) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.BCK) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.ALTYN) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.EURAZ) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }

    editDeal({
      dealId: savedDeal?.id,
      id: savedDeal?.id,
      statusId: DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT,
      ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT, DOCUMENT_TYPES_GUARANTEE_LETTER]),
    }).then(() => {
      setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
        update();
      });
    });
  };

  const dealComplete = () => {
    setStep({ dealId: savedDeal?.id, step: 10 }).then(() => {
      update();
    });
  };

  const onClientPaymentApproveSubmit = async () => {
    setLoading(true);
    try {
      let newStep = 6;

      if (chosenBankId === BANKS.HALYK) {
        newStep = DEAL_STEPS.HALYK.NOTARIAL_VERIFICATION;
      }
      if (chosenBankId === BANKS.FREEDOM) {
        newStep = DEAL_STEPS.FREEDOM.AUTO_REGISTRATION;
      }
      if (chosenBankId === BANKS.BCK) {
        newStep = DEAL_STEPS.BCK.NOTARIAL_VERIFICATION;
      }
      if (chosenBankId === BANKS.FORTE) {
        newStep = DEAL_STEPS.FORTE.NOTARIAL_VERIFICATION;
      }

      await editDeal({
        id: deal?.id,
        statusPaymentId: PAYMENT_STATUS_PAID,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
        ]),
      });
      await setStep({ dealId: savedDeal?.id, step: newStep });
      update();
    } catch (e) {
      toastAlert.error('Не удалось сменить статус сделки');
    }
  };
  const onClientRegistrationApproveSubmit = async () => {
    setLoading(true);
    try {
      let newStep = 6;

      if (chosenBankId === BANKS.HALYK) {
        newStep = DEAL_STEPS.HALYK.CAR_DELIVERY;
      }
      if (chosenBankId === BANKS.FREEDOM) {
        newStep = DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS;
      }
      if (chosenBankId === BANKS.BCK) {
        newStep = DEAL_STEPS.BCK.CAR_DELIVERY;
      }
      if (chosenBankId === BANKS.FORTE) {
        newStep = DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_MOBILE_APP;
      }

      await editDeal({
        id: deal?.id,
        statusPaymentId: PAYMENT_STATUS_PAID,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
        ]),
      });
      await setStep({ dealId: savedDeal?.id, step: newStep });
      update();
    } catch (e) {
      toastAlert.error('Не удалось сменить статус сделки');
    }
  };

  const backHandler = (e, step) => {
    e.preventDefault();
    // setCurrentStep(currentStep - 1);
    setStep({ dealId: deal?.id, step: step || currentStep - 1 }).then(() => {
      update && update();
    });
  };

  const removeEquipment = (id) => {
    setLoading(true);
    removeItemsToDeal({
      equipments: [{ value: id }],
      dealId: deal?.id,
    })
      .then(() => {
        update();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const removeService = (id) => {
    setLoading(true);
    removeItemsToDeal({
      services: [{ value: id }],
      dealId: deal?.id,
    })
      .then(() => {
        update();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // если по сделке уже подавалась заявка в банк — показываем цену из неё
    // (замороженную на момент подачи), а не текущий пересчёт по составу заказа,
    // который может измениться после подачи заявки
    const sum = savedDeal?.creditAppeal?.fullPrice ?? savedDeal?.sum ?? 0;
    const sum2 =
      unsavedEquipments?.reduce((acc, item) => {
        return acc + item?.price * item?.n;
      }, 0) || 0;
    const sum3 =
      unsavedServices?.reduce((acc, item) => {
        return acc + item?.price;
      }, 0) || 0;
    setSum(sum + sum2 + sum3);
  }, [savedDeal, cars, equipments, unsavedEquipments, unsavedServices]);

  useEffect(() => {
    setCurrentStep(savedDeal?.step || 1);
  }, [savedDeal]);

  const updateCurrentStep = (step) => {
    setStep({ dealId: savedDeal?.id, step }).then(() => {
      update();
    });
  };

  const back = (step) => {
    return (
      <Button
        text={'Назад'}
        disabled={loading}
        onClick={(e) => backHandler(e, step)}
        style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
      />
    );
  };

  return (
    <>
      <Header title={'Новая сделка'} icon={leads} />
      <Breadcrumbs navigate={'/deals'} link={'Сделки'} currentPage={'Новая сделка'} />
      <SendAppealProgress
        open={shouldShowSendProgress({
          loading: sendFormLoading,
          banks: sendProgress?.banks,
          error: sendProgressError,
        })}
        total={sendProgress?.total || 0}
        banks={sendProgress?.banks || []}
        error={sendProgressError}
        onRetry={() => {
          const last = lastSubmitRef.current;
          setSendProgressError(null);
          if (last) handleCreateCreditSubmit(last.values, last.documents, last.files, last.showError);
        }}
        onClose={() => {
          setSendProgressError(null);
          setSendProgress(null);
        }}
      />
      <div className={styles.DealCreate}>
        <div className={styles.DealCreateForm} id="DealCreateForm">
          {loading ? (
            <LoaderInline />
          ) : (
            <>
              {currentStep === 1 && (
                <DealCreationMainInfo nextStep={onSubmitStep1} deal={deal} cars={cars} update={update} />
              )}
              {currentStep === 2 && (
                <DealCreateEquipment
                  deal={deal}
                  equipments={equipments}
                  setUnsavedEquipments={setUnsavedEquipments}
                  orders={orders}
                  onSubmit={onEquipmentSubmit}
                  update={update}
                  dealCars={cars}
                  backHandler={back}
                />
              )}
              {(currentStep === 3 || currentStep === 311) && (
                <DealCreateServices
                  onSubmit={(services, orderId) => {
                    // onSubmitStep3(services, orderId, currentStep === 3 ? 311 : 4)
                    onSubmitStep3(services, orderId, 4);
                  }}
                  paymentType={savedDeal?.paymentType?.id}
                  deal={deal}
                  services={services}
                  orders={orders}
                  update={update}
                  setUnsavedServices={setUnsavedServices}
                  setLoading={setLoading}
                  backHandler={() => back(currentStep === 311 ? 3 : null)}
                  dealCars={cars}
                  enableInsurance={currentStep === 311}
                />
              )}
              {currentStep === 4 && !isCreditDeal && (
                <DealCreatePayment
                  onSubmit={onSubmitStep4}
                  deal={deal}
                  documents={documents}
                  update={update}
                  backHandler={() => back(311)}
                  cars={cars}
                />
              )}
              {currentStep === 4 && isCreditDeal && (
                <DealCreateCreditAppeal
                  onSubmit={handleCreateCreditSubmit}
                  deal={deal}
                  documents={documents}
                  orders={orders}
                  agreementModal={agreementModal}
                  setAgreementModal={setAgreementModal}
                  backHandler={() => back(311)}
                  sendFormLoading={sendFormLoading}
                  creditAppeals={creditAppeals}
                  usedCar={usedCar}
                />
              )}

              {currentStep === 5 && !isCreditDeal && (
                <DealCreateDocs
                  onSubmit={onSubmitStep4}
                  deal={deal}
                  documents={documents}
                  update={update}
                  backHandler={back}
                  cars={cars}
                />
              )}
              {currentStep === 6 && !isCreditDeal && (
                <DealCreateOther
                  onSubmit={onSubmitStep5}
                  deal={deal}
                  update={update}
                  documents={documents}
                  backHandler={back}
                  cars={cars}
                />
              )}
              {currentStep === 5 && isCreditDeal && (
                <DealCreateBanks
                  deal={deal}
                  onSubmit={onBankSelect}
                  backHandler={back}
                  services={services}
                  update={update}
                  documents={documents}
                  orders={orders}
                />
              )}
              {/* {currentStep === 6 && isCreditDeal && (
                <DealCreateBanksPay deal={deal} onSubmit={dealComplete} documents={documents} backHandler={back} />
              )} */}
              {/* Шаги 4 и 5 — общие: у кредита это «Банк» и поток банка, у наличных
                  «Оплата» и ДКП (DealCreateDocs). Договор встаёт между ними. */}
              {currentStep === DEAL_STEPS.TRIPARTITE_CONTRACT && (
                <TripartiteContractStep
                  deal={deal}
                  prevStep={isCreditDeal ? 5 : 4}
                  nextStep={isCreditDeal ? (chosenBankId ? bankFirstStep(chosenBankId, chosenBankAppeal) : null) : 5}
                  update={update}
                />
              )}
              {currentStep == DEAL_STEPS.SIGN_CONTRACT && (
                <ContractSign
                  deal={deal}
                  documents={documents}
                  cars={cars}
                  dealStepAfterSign={DEAL_STEPS.NOTARIAL_DOCUMENTS}
                  setLoading={setLoading}
                  update={update}
                />
              )}
              {currentStep === 6 && isCreditDeal && (
                <DealCreateCreditDocuments
                  deal={deal}
                  update={update}
                  onSubmit={dealComplete}
                  documents={documents}
                  backHandler={back}
                  chosenBankAppealId={chosenBankAppealId}
                />
              )}
              {currentStep === 7 && isCreditDeal && (
                <DealCreatePledgeRegistration
                  deal={deal}
                  update={update}
                  onSubmit={dealComplete}
                  documents={documents}
                  backHandler={back}
                />
              )}
              {chosenBankId && currentStep === DEAL_STEPS.CLIENT_PAYMENT_APPROVE && (
                <ClientPaymentApprove onSubmit={onClientPaymentApproveSubmit} />
              )}
              {chosenBankId && currentStep === DEAL_STEPS.CLIENT_REGISTRATION_APPROVE && (
                <ClientRegistrationApprove onSubmit={onClientRegistrationApproveSubmit} />
              )}
              {chosenBankId === BANKS.HALYK && (
                <HalykFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  cars={cars}
                  chosenBankAppealId={chosenBankAppealId}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.ALTYN && (
                <AltynFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  cars={cars}
                  chosenBankAppealId={chosenBankAppealId}
                  bankId={chosenBankId}
                  setLoading={setLoading}
                />
              )}
              {chosenBankId === BANKS.FREEDOM && (
                <FreedomFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  chosenBankAppeal={chosenBankAppeal}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.FORTE && (
                <ForteFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.BEREKE && (
                <BerekeFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.BCK && (
                <BCCFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.EURAZ && (
                <EurazFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                  chosenBankAppeal={chosenBankAppeal}
                />
              )}
            </>
          )}
        </div>
        <DealCreationSteps
          currentStep={currentStep}
          setCurrentStep={updateCurrentStep}
          state={state}
          sum={sum}
          deal={savedDeal}
          equipments={equipments}
          services={services}
          cars={cars}
          removeEquipment={removeEquipment}
          removeService={removeService}
          documents={documents}
          chosenBankId={chosenBankId}
          update={update}
          chosenBankAppealId={chosenBankAppealId}
          chosenBankAppeal={chosenBankAppeal}
          creditAppeals={creditAppeals}
        />
      </div>

      {succes.message && <Alert message={succes.message} onClick={setSucces} />}
    </>
  );
};

export default DealCreate;
